/* eslint-disable */
import {
  APPEND_MESSAGE_TO_CONVERSATION,
  FETCH_CONVERSATION_MESSAGE_FAILED,
  FETCH_CONVERSATION_MESSAGE_REQUEST,
  FETCH_CONVERSATION_MESSAGE_SUCCESS,
  FETCH_SINGLE_MESSAGE_FAILED,
  FETCH_SINGLE_MESSAGE_REQUEST,
  FETCH_SINGLE_MESSAGE_SUCCESS,
  UPDATE_CONVERSATION_MESSAGE,
} from './actionCreator';

const initialState = {
  conversations: [],
  singleMessage: null,
  loading: false,
  error: null,
};

const conversationsMessagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CONVERSATION_MESSAGE_REQUEST:
    case FETCH_SINGLE_MESSAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_CONVERSATION_MESSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        conversations: action.payload,
        error: null,
      };

    case FETCH_SINGLE_MESSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        singleMessage: action.payload,
        error: null,
      };

    case FETCH_CONVERSATION_MESSAGE_FAILED:
    case FETCH_SINGLE_MESSAGE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CONVERSATION_MESSAGE:
      return {
        ...state,
        conversations: state.conversations.map((convo) => (convo._id === action.payload._id ? action.payload : convo)),
      };

    case APPEND_MESSAGE_TO_CONVERSATION:
      return {
        ...state,
        conversations: state.conversations.map((convo) =>
          convo.conversationId === action.payload.conversationId
            ? {
                ...convo,
                messages: [...convo.messages, action.payload.message],
              }
            : convo,
        ),

        singleMessage:
          state.singleMessage && state.singleMessage.conversationId === action.payload.conversationId
            ? {
                ...state.singleMessage,
                messages: [...(state.singleMessage.messages || []), action.payload.message],
              }
            : state.singleMessage,
      };

    default:
      return state;
  }
};

export default conversationsMessagesReducer;
